import axios from 'axios';
import { ENDPOINTS } from './ENDPOINTS';

export const AddonServices = {

    addAddonServices: async (data) => {
        try {
            const response = await axios.post(ENDPOINTS.addon_services, data);
            return response.data;
        } catch (error) {
            console.error("Error creating break type:", error);
            throw error;
        }
    },
    updateAddonServices: async (id, data) => {
        try {
            const response = await axios.put(`${ENDPOINTS.addon_services}/${id}`, data);
            return response.data;
        } catch (error) {
            console.error("Error creating break type:", error);
            throw error;
        }
    },
  
    AddonServicesById: async (id) => {
        try {
            const response = await axios.get(`${ENDPOINTS.addon_services}/${id}`);
            return response.data;
        } catch (error) {
            console.error("Error creating break type:", error);
            throw error;
        }
    },
    getAllAddonServices: async () => {
        try {
            const response = await axios.get(ENDPOINTS.addon_services);
            return response.data;
        } catch (error) {
            console.error("Error creating break type:", error);
            throw error;
        }
    },
    deleteAddonServicesById: async (id) => {
        try {
            const response = await axios.delete(`${ENDPOINTS.addon_services}/${id}`);
            return response.data;
        } catch (error) {
            console.error("Error creating break type:", error);
            throw error;
        }
    },

    // services

    addServices: async (data) => {
        try {
            const response = await axios.post(ENDPOINTS._services, data,
                { headers: { "Content-Type": "multipart/form-data" },
        });
            return response.data;
        } catch (error) {
            console.error("Error creating break type:", error);
            throw error;
        }
    },
    updateServices: async (id, data) => {
        try {
            const response = await axios.put(`${ENDPOINTS._services}/${id}`, data , { headers: { "Content-Type": "multipart/form-data" },
        });
            return response.data;
        } catch (error) {
            console.error("Error creating break type:", error);
            throw error;
        }
    },
  
    ServicesById: async (id) => {
        try {
            const response = await axios.get(`${ENDPOINTS._services}/${id}`);
            return response.data;
        } catch (error) {
            console.error("Error creating break type:", error);
            throw error;
        }
    },
    getAllServices: async () => {
        try {
            const response = await axios.get(ENDPOINTS._services);
            return response.data;
        } catch (error) {
            console.error("Error creating break type:", error);
            throw error;
        }
    },
    deleteServicesById: async (id) => {
        try {
            const response = await axios.delete(`${ENDPOINTS._services}/${id}`);
            return response.data;
        } catch (error) {
            console.error("Error creating break type:", error);
            throw error;
        }
    },

    // coupons and offere


    addCouponOffers: async (data) => {
        try {
            const response = await axios.post(ENDPOINTS.coupons_services, data);
            return response.data;
        } catch (error) {
            console.error("Error creating break type:", error);
            throw error;
        }
    },
    updateCouponOffers: async (id, data) => {
        try {
            const response = await axios.put(`${ENDPOINTS.coupons_services}/${id}`, data);
            return response.data;
        } catch (error) {
            console.error("Error creating break type:", error);
            throw error;
        }
    },
  
    CouponOffersById: async (id) => {
        try {
            const response = await axios.get(`${ENDPOINTS.coupons_services}/${id}`);
            return response.data;
        } catch (error) {
            console.error("Error creating break type:", error);
            throw error;
        }
    },
    getAllCouponOffers: async () => {
        try {
            const response = await axios.get(ENDPOINTS.coupons_services);
            return response.data;
        } catch (error) {
            console.error("Error creating break type:", error);
            throw error;
        }
    },
    deleteCouponOffersById: async (id) => {
        try {
            const response = await axios.delete(`${ENDPOINTS.coupons_services}/${id}`);
            return response.data;
        } catch (error) {
            console.error("Error creating break type:", error);
            throw error;
        }
    },
   

    // drivers


    addDriver: async (data) => {
        try {
            const response = await axios.post(ENDPOINTS.driver_services, data);
            return response.data;
        } catch (error) {
            console.error("Error creating break type:", error);
            throw error;
        }
    },
    updateDriver: async (id, data) => {
        try {
            const response = await axios.put(`${ENDPOINTS.driver_services}/${id}`, data);
            return response.data;
        } catch (error) {
            console.error("Error creating break type:", error);
            throw error;
        }
    },
  
    DriverById: async (id) => {
        try {
            const response = await axios.get(`${ENDPOINTS.driver_services}/${id}`);
            return response.data;
        } catch (error) {
            console.error("Error creating break type:", error);
            throw error;
        }
    },
    getAllDriver: async () => {
        try {
            const response = await axios.get(ENDPOINTS.driver_services);
            return response.data;
        } catch (error) {
            console.error("Error creating break type:", error);
            throw error;
        }
    },
    deleteDriverById: async (id) => {
        try {
            const response = await axios.delete(`${ENDPOINTS.driver_services}/${id}`);
            return response.data;
        } catch (error) {
            console.error("Error creating break type:", error);
            throw error;
        }
    },
   
}